import { useCallback } from 'react';

import { useGetToolsQuery } from '@backrs_ui/grow-ui/src/redux/tools/tools.api';

export const useGetSessionToolTitle = (): ((
  sessionId: string | null | undefined,
) => string | undefined) => {
  const { data: tools } = useGetToolsQuery(undefined);

  return useCallback(
    (sessionId) => {
      if (!sessionId || !tools) return undefined;

      return tools.find((tool) => tool.structured_session_type === sessionId)?.title;
    },
    [tools],
  );
};

export const useSessionToolTitle = (sessionId: string | null): string | undefined =>
  useGetSessionToolTitle()(sessionId);
